<template>
    <div class="user">
        <div class="search">
            {{$t('status')}}：<Select v-model="search.status" style="width:200px">
                <Option value="" >{{$t('pleaseSelect')}}</Option>
                <Option value="1" >{{$t('up')}}</Option>
                <Option value="0" >{{$t('down')}}</Option>
            </Select>
            <Button type="primary" @click="loadData(currentPage)">{{$t('searchText')}}</Button>
            <Button type="primary" class="add_user" icon="md-add" @click="show_add_manager = true">{{$t('add')}}{{$t('new_vendor')}}</Button>
        </div>
        <Table border :columns="columns12" :data="managerList">
            <template slot-scope="{ row }" slot="image">
                <img :src="row.image" style="width:100%;"></img>
            </template>
            <template slot-scope="{ row }" slot="zhanshitu">
              <img
                v-for="(img, index) in row.zhanshitu_final"
                :key="index"
                :src="img"
                style="width: 60px; height: 60px; object-fit: cover; border-radius: 4px; cursor: pointer;"
                @click="previewImage(row.zhanshitu_final, index)"
              />
            </template>
            <template slot-scope="{ row }" slot="beishu">
                <img
                  v-for="(img, index) in row.beishu_final"
                  :key="index"
                  :src="img"
                  style="width: 60px; height: 60px; object-fit: cover; border-radius: 4px; cursor: pointer;"
                  @click="previewImage(row.beishu_final, index)"
                />
            </template>
            <template slot-scope="{ row }" slot="brand">
                <span v-if="brandListMap">{{ brandListMap.get(row.brand_id).name_cn }}</span>
            </template>
            <template slot-scope="{ row }" slot="color">
                <span v-if="colorListMap">{{ colorListMap.get(row.color_id).color_cn }}</span>
            </template>
            <template slot-scope="{ row }" slot="drive">
                <span v-if="driveListMap">{{ driveListMap.get(row.drive_id).drive_cn }}</span>
            </template>
            <template slot-scope="{ row }" slot="energy">
                <span v-if="energyListMap">{{ energyListMap.get(row.energy_id).energy_cn }}</span>
            </template>
            <template slot-scope="{ row }" slot="gear">
                <span v-if="gearListMap">{{ gearListMap.get(row.gear_id).gear_cn }}</span>
            </template>
            <template slot-scope="{ row }" slot="price_price">
                <span>{{ row.price }}$</span>
            </template>
            <template slot-scope="{ row }" slot="licheng">
                <span>{{ row.licheng }}万公里</span>
            </template>
            <template slot-scope="{ row }" slot="fadongji">
                <span>{{ row.fadongji }}T</span>
            </template>
            <template slot-scope="{ row }" slot="youhao">
                <span>{{ row.youhao }}L</span>
            </template>
            <template slot-scope="{ row }" slot="price">
                <span v-if="priceListMap">{{ priceListMap.get(row.price_id).price_min }}$ -{{ priceListMap.get(row.price_id).price_max }}$</span>
            </template>
            <template slot-scope="{ row }" slot="is_open">
                <Tag color="green" v-if="row.is_open==1">{{$t('coin.already')}}{{$t('up')}}</Tag>
                <Tag color="red" v-else>{{$t('coin.already')}}{{$t('down')}}</Tag>
            </template>
            <template slot-scope="{ row, index }" slot="action">
                <div class="op_btn">
                    <Button
                        type="info"
                        size="small"
                        style="margin-right: 5px"
                        @click="showManagerDetail(row.id)"
                    >{{$t('coin.edit')}}</Button>
                    <Button
                        v-if="row.is_open == 0"
                        type="success"
                        size="small"
                        style="margin-right: 5px"
                        @click="openModal(row)"
                    >{{$t('up')}}</Button>
                    <Button
                        v-if="row.is_open == 1"
                        type="warning"
                        size="small"
                        style="margin-right: 5px"
                        @click="openModal(row)"
                    >{{$t('down')}}</Button>
                    <!--Button
                        type="error"
                        size="small"
                        style="margin-right: 5px"
                        @click="showDelManager(row)"
                    >{{$t('announcement.del')}}</Button-->
                </div>
            </template>
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>
        <Modal v-model="show_add_manager" :title="$t('add')+$t('new_vendor')" :footer-hide="true" @on-ok="add_manager">
            <Form :model="modalAdd" :label-width="100">
                <Form :model="modalAdd" :label-width="100">
                  <FormItem :label="$t('vendor_cn')">
                      <Input type="text" v-model="modalAdd.title_cn"></Input>
                  </FormItem>
                  <FormItem :label="$t('vendor_en')">
                      <Input type="text" v-model="modalAdd.title_en"></Input>
                  </FormItem>
                  <FormItem :label="$t('vendor_lao')">
                      <Input type="text" v-model="modalAdd.title_lao"></Input>
                  </FormItem>
                  <FormItem :label="$t('vendor_desc_cn')">
                      <Input type="text" v-model="modalAdd.c_desc_cn"></Input>
                  </FormItem>
                  <FormItem :label="$t('vendor_desc_en')">
                      <Input type="text" v-model="modalAdd.c_desc_en"></Input>
                  </FormItem>
                  <FormItem :label="$t('vendor_desc_lao')">
                      <Input type="text" v-model="modalAdd.c_desc_lao"></Input>
                  </FormItem>
                  <FormItem :label="$t('image')">
                      <div class="image-section">
                        <img
                          v-model="modalAdd.image"
                          v-if="modalAdd.image"
                          :src="modalAdd.image"
                          class="card-image"
                          @click="identityFrontChooseImage"
                        />
                        <div
                          v-else
                          class="upload-area"
                          @click="identityFrontChooseImage"
                        >
                          <div class="upload-placeholder">
                            <span class="plus-icon">+</span>
                            <span>{{ $t('coin.new_upload') }}</span>
                          </div>
                        </div>
                      </div>
                  </FormItem>
                  <FormItem :label="$t('zhanshitu')">
                    <div class="image-section">
                        <!-- 显示已上传的图片 -->
                        <div class="image-list">
                          <div
                            v-for="(image, index) in modalAdd.zhanshitu"
                            :key="index"
                            class="image-item"
                          >
                            <img
                              :src="image.url"
                              class="card-image"
                            />
                            <div class="image-actions">
                              <Icon
                                type="md-close"
                                class="delete-icon"
                                @click="removeImage(index,0)"
                              />
                              <span class="image-index">{{ index + 1 }}</span>
                            </div>
                          </div>

                          <!-- 上传按钮 -->
                          <div
                            class="upload-area"
                            @click="chooseImages(0)"
                          >
                            <div class="upload-placeholder">
                              <Icon type="md-add" class="plus-icon" />
                              <span>{{ $t('coin.new_upload') }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                  </FormItem>
                  <FormItem :label="$t('manager.is_open')">
                      <Select v-model="modalAdd.is_open">
                          <Option value="1">{{$t('up')}}</Option>
                          <Option value="0">{{$t('down')}}</Option>
                      </Select>
                  </FormItem>
                </Form>
            </Form>

            <div style="text-align: right;">
              <Button @click="cancel_add">取消</Button>
              <Button type="primary" @click="add_manager">
                {{ '保存' }}
              </Button>
            </div>
        </Modal>

        <Modal
            v-model="showOkModal"
            :title="$t('coin.confirmOk')"
            @on-ok="change_staust(1)"
            @on-cancel="showOkModal=false"
        >
        </Modal>
        <Modal
            v-model="showCancelModal"
            :title="$t('coin.confirmCancel')"
            @on-ok="change_staust(0)"
            @on-cancel="showCancelModal=false"
        >
        </Modal>
        <Modal
            v-model="showDelModal"
            :title="$t('confirmDel')"
            @on-ok="delManager();"
            @on-cancel="showDelModal=false"
        >
            <p>{{$t('confirmDel')}}</p>
        </Modal>
    </div>
</template>


<script>
export default {
    data() {
        return {
            modalItem: {},
            showDelModal: false,
            userIdToDel: 0,
            currentPage: 1,
            totalItems: 0,
            totalPages: 1,
            totalItems: 1,
            itemsPerPage: 10,
            showOkModal: false,
            showCancelModal: false,
            search:{
                status:''
            },
            columns12: [
                {
                    title: "ID",
                    width: 60,
                    key: "id"
                },
                {
                    title: this.$i18n.t('vendor_cn'),
                    width: 150,
                    key: "title_cn"
                },
                {
                    title: this.$i18n.t('vendor_en'),
                    width: 150,
                    key: "title_en"
                },
                {
                    title: this.$i18n.t('vendor_lao'),
                    width: 150,
                    key: "title_lao"
                },
                {
                    title: this.$i18n.t('vendor_desc_cn'),
                    width: 150,
                    key: "c_desc_cn"
                },
                {
                    title: this.$i18n.t('vendor_desc_en'),
                    width: 150,
                    key: "c_desc_en"
                },
                {
                    title: this.$i18n.t('vendor_desc_lao'),
                    width: 150,
                    key: "c_desc_lao"
                },
                {
                    title: this.$i18n.t('image'),
                    width: 150,
                    slot: "image"
                },
                {
                    title: this.$i18n.t('zhanshitu'),
                    width: 450,
                    slot: "zhanshitu"
                },
                {
                    title: this.$i18n.t('manager.is_open'),
                    width: 120,
                    key: "is_open",
                    slot: "is_open"
                },
                {
                    title: this.$i18n.t('action'),
                    slot: "action",
                    width: 200,
                    align: "center",
                    fixed:"right"
                }
            ],
            managerList: [],
            modalAdd: { id: 0, image: "", title_cn: "", title_en: "", title_lao: "",
                   c_desc_cn: "", c_desc_en: "", c_desc_lao: "", zhanshitu: [], is_open: "1" },
            show_add_manager: false,
            modalLoading: false,
            colorList: null,
            driveList: null,
            gearList: null,
            brandList: null,
            energyList: null,
            priceList: null,
            categoryList: null,
            tagList: null,
            colorListMap: null,
            driveListMap: null,
            gearListMap: null,
            brandListMap: null,
            energyListMap: null,
            priceListMap: null,
            categoryListMap: null,
            tagListMap: null
        };
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.currentPage = page;
            let query = Object.assign({"page":this.currentPage},{
                status: this.search.status,
                page: this.currentPage
            });
            this.$get(this.$path.vendor_list, query).then(res => {
                if (res.data) {
                  console.log(res.data);
                    this.managerList = res.data.data;
                    this.totalItems = res.data.total;
                    this.itemsPerPage = res.data.last_page;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        previewImage(images, index) {
          // 图片预览逻辑
          this.$Modal.info({
            title: '图片预览',
            content: `
              <div style="text-align: center;">
                <img src="${images[index]}" style="max-width: 100%; max-height: 400px;" />
                <div style="margin-top: 10px; color: #666;">
                  图片 ${index + 1} / ${images.length}
                </div>
              </div>
            `,
            width: 600
          });
        },
        openModal(row) {
          this.modalItem = row;
          if(this.modalItem.is_open == 1){
            this.showCancelModal = true;
          }else{
            this.showOkModal = true;
          }
        },
        change_staust(status) {
          this.$post(this.$path.change_vendor_info, {
              id: this.modalItem.id,
              status: status
          }).then(res => {
              if (res.success) {
                  this.$Message.success(this.$i18n.t('operateSuccess'));
                  this.loadData(this.currentPage);
              }
          });
        },
        /*showDelManager(row) {
          this.modalItem = row;
          this.showDelModal = true;
        },
        delManager() {
          this.$post(this.$path.del_vendor, {
              id: this.modalItem.id
          }).then(res => {
              if (res.success) {
                  this.$Message.success(this.$i18n.t('operateSuccess'));
                  this.loadData(this.currentPage);
                  this.modalAdd = { id: 0, type: 1, image: "", title_cn: "", title_en: "", title_lao: "",
                   c_desc_cn: "", c_desc_en: "", c_desc_lao: "", zhanshitu: "", beishu: "", year: "", licheng: "", fadongji: "", youhao: "", brand_id: 0, category: [],
                    color_id: 0, drive_id: 0, energy_id: 0, gear_id: 0, price_id: 0, tag: [], is_open: "1" };
              }
          });
        },*/
        showManagerDetail(id){
          for(let ann of this.managerList){
            if(ann.id == id){
              this.modalAdd.id = ann.id;
              this.modalAdd.image = ann.image;
              this.modalAdd.title_cn = ann.title_cn;
              this.modalAdd.title_en = ann.title_en;
              this.modalAdd.title_lao = ann.title_lao;
              this.modalAdd.c_desc_cn = ann.c_desc_cn;
              this.modalAdd.c_desc_en = ann.c_desc_en;
              this.modalAdd.c_desc_lao = ann.c_desc_lao;
              if(ann.zhanshitu == ""){
                this.modalAdd.zhanshitu = [];
              }else{
                this.modalAdd.zhanshitu = [];
                let zhanshitu = ann.zhanshitu.split(',');
                for(let zs of zhanshitu){
                  if(zs != ""){
                   this.modalAdd.zhanshitu.push({"url": zs});
                  }
                }
              }
              this.modalAdd.is_open = ann.is_open.toString();
              this.show_add_manager = true;
              break;
            }
          }
        },
        add_manager() {
          if(this.modalAdd.zhanshitu.length <= 0){
            this.$Message.success("至少需要一张展示图");
            return;
          }

          if(this.modalAdd.image == ""){
            this.$Message.success("请上传头图");
            return;
          }

          if(this.modalAdd.title_cn == ""){
            this.$Message.success("中文标题");
            return;
          }

          if(this.modalAdd.title_en == ""){
            this.$Message.success("英文标题");
            return;
          }

          if(this.modalAdd.title_lao == ""){
            this.$Message.success("老挝语标题");
            return;
          }

          if(this.modalAdd.c_desc_cn == ""){
            this.$Message.success("中文描述");
            return;
          }

          if(this.modalAdd.c_desc_en == ""){
            this.$Message.success("英文描述");
            return;
          }

          if(this.modalAdd.c_desc_lao == ""){
            this.$Message.success("老挝语描述");
            return;
          }

          let zhanshitu = this.modalAdd.zhanshitu;
          let zhanshitu_string = "";
          for(let zs of zhanshitu){
            zhanshitu_string += zs.url + ",";
          }
          this.modalAdd.zhanshitu = zhanshitu_string;

          this.$post(this.$path.add_vendor_info, this.modalAdd).then(res => {
              if (res.success) {
                  this.$Message.success(this.$i18n.t('operateSuccess'));
                  this.loadData(this.currentPage);
                  this.show_add_manager=false;
                  this.modalAdd = { id: 0, image: "", title_cn: "", title_en: "", title_lao: "",
                   c_desc_cn: "", c_desc_en: "", c_desc_lao: "", zhanshitu: [], is_open: "1" };
              }
          });
        },
        cancel_add(){
          this.show_add_manager=false;
          this.modalAdd = { id: 0, image: "", title_cn: "", title_en: "", title_lao: "",
                   c_desc_cn: "", c_desc_en: "", c_desc_lao: "", zhanshitu: [], is_open: "1" };
        },
        /**
         * 选择身份证正面照片
         */
        async identityFrontChooseImage() {
          try {
            // 创建文件输入元素
            const input = document.createElement('input')
            input.type = 'file'
            input.accept = 'image/*'

            input.onchange = async (event) => {
              const file = event.target.files[0]
              if (file) {
                await this.uploadImage(file);
              }
            }

            input.click()
            this.showPopup = false
          } catch (error) {
            console.error(error)
          }
        },
        /**
         * 上传文件处理
         */
        async uploadImage(file) {
            const formData = new FormData()
            formData.append('img', file)
            //this.$toast.showLoading(this.$t('mine.introduce.loading'))
            this.$file(this.$path.upload, formData)
            .then(async res => {
              //this.$toast.hideLoading();
              if (res.success === true) {
                this.modalAdd.image = (this.$path.ip + res.data.path)
              }else{

              }
            })
            .catch(err => {
              //this.$toast.hideLoading();
            })
        },

        /**
         * 上传文件处理
         */
        async uploadImage_s(files, type) {
          if (!files.length) return;
          const maxCount = 15;
          if(type == 0){
            if (this.modalAdd.zhanshitu.length + files.length > maxCount) {
              this.$Message.warning(`最多只能上传 ${maxCount} 张图片`);
              return;
            }
          }

          for (let i = 0; i < files.length; i++) {
            const file = files[i];
            // 验证文件类型
            if (!file.type.startsWith('image/')) {
              this.$Message.warning(`文件 ${file.name} 不是图片格式`);
              continue;
            }

            // 验证文件大小（例如5MB）
            const maxSize = 5 * 1024 * 1024;
            if (file.size > maxSize) {
              this.$Message.warning(`图片 ${file.name} 大小不能超过5MB`);
              continue;
            }

            const formData = new FormData()
            formData.append('img', file)
            //this.$toast.showLoading(this.$t('mine.introduce.loading'))
            this.$file(this.$path.upload, formData)
            .then(async res => {
              //this.$toast.hideLoading();
              if (res.success === true) {
                let url = (this.$path.ip + res.data.path);
                if(type == 0){
                  this.modalAdd.zhanshitu.push({
                    url
                  });
                }
              }else{

              }
            })
            .catch(err => {
              //this.$toast.hideLoading();
            })
          }
        },
        chooseImages(type) {
          // 创建文件输入框
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/*';
          input.multiple = true; // 允许多选
          input.onchange = async (event) => {
            await this.uploadImage_s(event.target.files, type);
          }
          input.click();
        },

        removeImage(index, type) {
          // 释放URL对象
          if(type == 0){
            this.modalAdd.zhanshitu.splice(index, 1);
          }
        }
      }

};
</script>


<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
    .add_user {
        float: right;
    }
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.upload-area {
  width: 100px;
  height: 100px;
  background: #f8f9fa;
  border: 2px dashed #ccc;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;
}

.upload-placeholder {
  text-align: center;
  color: #999;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.plus-icon {
  font-size: 20px;
  line-height: 20px;
}

.image-section {
  margin-top: 10px;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.image-item {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  overflow: hidden;
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}

.image-actions {
  position: absolute;
  top: 2px;
  right: 2px;
  display: flex;
  align-items: center;
}

.delete-icon {
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border-radius: 50%;
  padding: 2px;
  cursor: pointer;
  font-size: 14px;
}

.delete-icon:hover {
  background: rgba(255, 0, 0, 0.7);
}

.image-index {
  background: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 10px;
  margin-left: 4px;
}

.upload-area {
  width: 100px;
  height: 100px;
  border: 1px dashed #dcdee2;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #fafafa;
}

.upload-area:hover {
  border-color: #409eff;
  background: #ecf5ff;
}

.upload-placeholder {
  text-align: center;
  color: #8c8c8c;
}

.plus-icon {
  font-size: 24px;
  color: #409eff;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/kefu/kefu.vue